import { IExportPlugin, PluginType } from '@/version-types';
import { RenderUserCursor } from './view/render-user-cursor';

const exportPlugin: IExportPlugin = {
    type: PluginType.STAGE,
    sort: 10,
    name: 'real-edit-cursor',
    render() {
        return <RenderUserCursor />;
    },
};

export default exportPlugin;
